import React from 'react'

const InductionReport = () => {
  return (
    <div>InductionReport</div>
  )
}

export default InductionReport